import { Component } from '@angular/core';
import { BaseComponent } from './base.component';
import { DataService } from './service/data.service';
import { WorkflowService } from './service/workflow/workflow.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent extends BaseComponent {
  title = 'app';


  constructor(data: DataService, private workflowService: WorkflowService) {
    super(data);
  }
}
